<script setup>
import Card from "~/components/ui/Card.vue";
import Button from "~/components/public/Button.vue";

const publicSiteData = useState('publicSiteData');
const { data: policies } = await publicFetch(`/public-sites/policy-books`);

const policyLastUpdatedDate = (policy) => {
    if (!policy.updated_at)
        return '';
    const date = new Date(policy.updated_at.date);
    return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
};

</script>

<template>
    <Card>
        <div class="flex flex-col justify-between h-full">
            <div class="flex-1 mb-6" v-for="policy in policies" :key="policy.id">
                <div class="flex justify-between">
                    <div class="flex gap-6 items-center">
                        <div class="mt-1">
                            <font-awesome :icon="['fad', 'book']" class="text-gray-600 self-center w-7 h-7"/>
                        </div>
                        <div>
                            <NuxtLink :to="`/${publicSiteData.slug}/policies/${policy.slug}`" class="text-sm font-medium text-gray-900">
                                {{ policy.title }}
                            </NuxtLink>
                            <div class="text-xs text-gray-700">Last updated {{ policyLastUpdatedDate(policy) }}</div>
                        </div>
                    </div>
                    <div>
                        <Button size="small" :to="`/${publicSiteData.slug}/policies/${policy.slug}`" :aria-label="`View ${policy.title}`">View</Button>
                    </div>
                </div>
            </div>

            <div class="text-center mt-6 text-sm font-light">
                <NuxtLink :to="`/${publicSiteData.slug}/policies`" class="underline">View all policies</NuxtLink>
            </div>
        </div>
    </Card>
</template>
